var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 50 50",
    width: "50pt",
    height: "50pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_UcfO96kGrtjIvuO7GOJtJXrDF9xUBIdL"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_UcfO96kGrtjIvuO7GOJtJXrDF9xUBIdL)"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 9.636 49.998 C 8.831 49.998 8.018 49.726 7.284 49.212 C 7.212 49.161 -0.087 43.834 0.001 40.982 C 0.276 32.442 8.581 22.412 15.5 15.496 C 22.419 8.578 32.452 0.273 40.958 0.002 L 40.959 0.002 C 43.909 0.002 49.171 7.21 49.222 7.283 C 50.505 9.122 50.06 11.157 48.909 11.986 C 48.097 12.572 39.642 18.149 38.683 18.756 C 37.741 19.355 36.287 19.254 34.863 18.502 C 34.022 18.061 31.398 16.567 30.258 15.917 C 29.263 16.605 26.693 18.534 22.617 22.611 C 18.517 26.711 16.604 29.261 15.92 30.251 C 16.571 31.392 18.065 34.018 18.507 34.86 C 19.258 36.28 19.357 37.702 18.769 38.662 C 18.163 39.654 12.552 48.096 11.998 48.889 C 11.51 49.584 10.628 49.998 9.636 49.998 L 9.636 49.998 Z ",
    fill: "rgb(255,255,255)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/IconPhone.a3536a1cd4b12690d9fccce240246f98.svg";
export { ForwardRef as ReactComponent };